import { useParams } from "react-router-dom";
import SidebarTopbar from "./layout";
import PdfView from "../common/PdfView";
import ChatBox from "../common/chatBox";
import { useState } from "react";

const PubChat = () => {
  const { id: publicationId } = useParams();
  const [highlightData, setHighlightData] = useState([]);

  return (
    <SidebarTopbar>
      <div style={{ display: "flex", flex: 1 }}>
        <PdfView publicationId={publicationId} highlightData={highlightData} />
        <ChatBox publicationId={publicationId} setHighlightData={setHighlightData} />
      </div>
    </SidebarTopbar>
  );
};

export default PubChat;
